<template>
  <div class="main-content" style="min-height: 766px">
    <section class="section">
      <div class="section-header">
        <h1>Exposure Report</h1>
      </div>

      <div class="section-body" v-if="role == 'admin'">
        <div class="row">
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-info">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Client NVT</h4>
                </div>
                <div class="card-body">
                  {{ totalNVT | numberFormat }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-info">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Hedge NVT</h4>
                </div>
                <div class="card-body">
                  {{ nvt.hedge | numberFormat }}
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-info">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Net NVT</h4>
                </div>
                <div class="card-body">
                  {{ (nvt.hedge - totalNVT) | numberFormat }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-primary">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Client Position</h4>
                </div>
                <div class="card-body">
                  {{ totalClientPosition | fixDouble }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-primary">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Hedge Position</h4>
                </div>
                <div class="card-body">
                  {{ totalHedgePosition | numberFormat }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-primary">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Net Position</h4>
                </div>
                <div class="card-body">
                  {{ totalHedgePosition - totalClientPosition | numberFormat }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-danger">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Client PL</h4>
                </div>
                <div class="card-body">
                  {{ totalClientPl | reverseValue | numberFormat }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-danger">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Hedge PL</h4>
                </div>
                <div class="card-body">{{ totalHedgePl | numberFormat }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="card card-statistic-1">
              <div class="card-icon bg-danger">
                <font-awesome-icon icon="user" color="white" />
              </div>
              <div class="card-wrap">
                <div class="card-header">
                  <h4>Total Net PL</h4>
                </div>
                <div class="card-body">
                  {{ totalNetPl | numberFormat }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-body">
        <div class="card">
          <div class="card-header">
            <h4>Open Position Table</h4>
            <div class="card-header-action">
              <div class="d-flex align-items-center justify-content-between">
                <button
                  class="btn btn-danger mr-2"
                  @click="excel"
                  v-if="tableView != 'symbol' && role == 'admin'"
                >
                  Excel
                </button>
                <button
                  class="btn btn-warning mx-1"
                  @click="exportExcel"
                  v-if="tableView == 'login' && role != 'user' && role != 'mib'"
                >
                  Export
                </button>
                <button
                  class="btn btn-sm btn-info mx-1"
                  @click="chooseFileImport"
                  v-if="tableView == 'login' && role != 'user' && role != 'mib'"
                >
                  Import
                </button>
                <input ref="file" type="file" accept=".csv" hidden />
                <b-form-select
                  v-model="tableView"
                  :options="options.display_format"
                  @change="switchTable"
                ></b-form-select>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-6 mb-2">
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="Type to Search"
                  ></b-form-input>
                </b-input-group>
              </div>

              <div class="col-sm-6 mb-2" v-if="tableView == 'login'">
                <!-- <div
                  class="card card-warning card-filter"
                  v-outside="customEvent"
                >
                  <div class="card-body">

                  </div>
                </div> -->
                <vue-range-slider
                  v-if="filterMarginCall"
                  v-model="fil.margin"
                  :min="fil.min"
                  :max="fil.max"
                  :enable-cross="true"
                  @drag-end="fetchData"
                ></vue-range-slider>
                <b-form-checkbox
                  class="float-right"
                  v-model="filterMarginCall"
                  name="check-button"
                  switch
                  @input="fetchData"
                >
                  Filter Margin Call
                </b-form-checkbox>
              </div>
              <div class="col-sm-12 mb-2" v-if="tableView != 'symbol'">
                <b-input-group size="sm">
                  <multiselect
                  v-model="filters.retention_name"
                  tag-placeholder="Add this name"
                  placeholder="Type retention name"
                  label="name"
                  track-by="code"
                  :options="[]"
                  :multiple="true"
                  :taggable="true"
                  @remove="removeRetention"
                  @tag="addUser"
                ></multiselect>
                </b-input-group>
              </div>
            </div>
            <p class="small">{{ status }}</p>
            <b-table
              class="tb-exposure"
              :sticky-header="true"
              :no-border-collapse="true"
              :filter="filter"
              striped
              hover
              bordered
              responsive
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
            >
              <template #table-busy>
                <div class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong> Loading...</strong>
                </div>
              </template>
              <!-- A virtual composite column -->
              <template v-slot:cell(login)="data">
                <a
                  href="#"
                  @click="displayBalance(data.item.login, data, $event)"
                  >{{ data.item.login }}</a
                >
              </template>
              <template v-slot:cell(client_float)="data">
                <span>{{ data.item.client_float | numberFormat }}</span>
              </template>

              <template v-slot:cell(hedge_float)="data">
                <span>{{ data.item.hedge_float | numberFormat }}</span>
              </template>

              <template v-slot:cell(hedge_position)="data">
                <span>{{ data.item.hedge_position | numberFormat }}</span>
              </template>

              <template v-slot:cell(client_position)="data">
                <span>{{ data.item.client_position | numberFormat }}</span>
              </template>

              <template v-slot:cell(total_net_pl)="data">
                <span>{{ data.item.total_net_pl | numberFormat }}</span>
              </template>

              <template v-slot:cell(net_position)="data">
                <span>{{ data.item.net_position | numberFormat }}</span>
              </template>

              <template v-slot:cell(client_settled)="data">
                <span>{{ data.item.client_settled | numberFormat }}</span>
              </template>

              <template v-slot:cell(hedge_settled)="data">
                <span>{{ data.item.hedge_settled | numberFormat }}</span>
              </template>

              <template v-slot:cell(total_client_pl)="data">
                <span>{{ data.item.total_client_pl | numberFormat }}</span>
              </template>

              <template v-slot:cell(lifetime_client_pl)="data">
                <span>{{ data.item.lifetime_client_pl | numberFormat }}</span>
              </template>

              <template v-slot:cell(total_hedge_pl)="data">
                <span>{{ data.item.total_hedge_pl | numberFormat }}</span>
              </template>
              <template v-slot:cell(margin_call)="data">
                <span>{{ data.item.margin_call | fixedOne }}%</span>
              </template>
              <template v-slot:cell(fpl)="data">
                <span>{{ data.item.fpl | numberFormat }}%</span>
              </template>
               <template v-slot:cell(is_flag)="data">
                <span>
                  <b-form-checkbox
                    v-model="data.item.is_flag"
                    value="1"
                    unchecked-value="0"
                    @input="loginChecked(data.item)"
                  >

                  </b-form-checkbox>
                </span>
              </template>
            </b-table>

          </div>
          <div class="card-footer bg-whitesmoke"></div>
        </div>
      </div>
    </section>

    <!-- Start Modal -->
    <b-modal
      ref="my-modal"
      size="xl"
      title="Account Information"
      @ok="handleOk"
    >
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group" v-if="role == 'admin' || role == 'operator' || role == 'mib'">
            <label class="control-label">Retention Name</label>
            <input
              class="form-control"
              v-model.lazy="modal.retention_name"
              placeholder="Type retention name here"
            />
          </div>
          <div class="form-group">
            <label class="control-label">Balance</label>
            <input class="form-control" v-model="modal.balance" disabled />
          </div>
          <div class="form-group">
            <label class="control-label">Equity</label>
            <input class="form-control" v-model="modal.equity" disabled />
          </div>
          <div class="form-group">
            <label class="control-label">Credit</label>
            <input class="form-control" v-model="modal.credit" disabled />
          </div>
          <div class="form-group" v-if="role == 'admin'">
            <label class="control-label">Client NVT</label>
            <input class="form-control" v-model="modal.total_nvt" disabled />
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="control-label">Client Position</label>
            <input
              class="form-control"
              v-model="modal.client_position"
              disabled
            />
          </div>
          <div class="form-group" v-if="role == 'admin'">
            <label class="control-label">Hedge Position</label>
            <input
              class="form-control"
              v-model="modal.hedge_position"
              disabled
            />
          </div>
          <div class="form-group" v-if="role == 'admin'">
            <label class="control-label">Net Position</label>
            <input class="form-control" v-model="modal.net_position" disabled />
          </div>
          <div class="form-group">
            <label class="control-label">Open Ticket/Deal</label>
            <input class="form-control" v-model="modal.total_open" disabled />
          </div>
          <div class="form-group">
            <label class="control-label">Closed Ticket/Deal</label>
            <input class="form-control" v-model="modal.total_close" disabled />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getOpenPositionv2, getBalanceInformation, updateUser, getNvtHedge, download } from "@/api/trade";
import { downloadExcel, uploadCsv, flagUser } from "@/api/user";
import { mapGetters } from 'vuex';
import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'
import Multiselect from 'vue-multiselect'

export default {
  data() {
    return {
      fields: [
        { key: "login", stickyColumn: true, sortable: true, label: 'Login' },
        { key: "retention_name", sortable: true, label: 'Retention Name' },
        { key: "margin_call", sortable: true, label: 'Margin Call' },
        { key: "client_position", sortable: true, label: 'Client Position' },
        { key: "lifetime_client_pl", sortable: true, label: 'Lifetime Client PL' },
        { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
        { key: "client_float", sortable: true, label: 'Client Float' },
        { key: "client_settled", sortable: true, label: 'Client Settled' },
        { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
        { key: "hedge_float", sortable: true, label: 'Hedge Float' },
        { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
        { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
      ],
      fil: {
        margin: [0, 100],
        min: 0,
        max: 500

      },
      isBusy: false,
      items: [],
      filter: null,
      tableView: "login",
      interval: null,
      filterMarginCall: false,
      filters: {
        retention_name : []
      },
      options: {
        display_format: [
          'symbol', 'login', 'both'
        ]
      },
      modal: {
        login: null,
        balance: null,
        equity: null,
        client_position: null,
        hedge_position: null,
        net_position: null,
        retention_name: null,
        index: 0,
        total_nvt: 0,
        total_open: 0,
        total_close: 0,
        credit: 0
      },
      nvt: {
        hedge: 0
      }

    };
  },
  components: {
    VueRangeSlider, Multiselect
  },
  filters: {
    fixedOne(value) {
      return value.toFixed(1)
    }
  },
  computed: {
    ...mapGetters(['role']),
    rows() {
      return this.items.length;
    },
    swText() {
      return this.tableView == "login"
        ? "Switch to Symbol Table"
        : "Switch to Login Table";
    },
    totalClientPosition() {
      let total = 0;

      this.items.forEach(item => {
        total += item.client_position_plus;
      });

      return total;
    },
    totalNVT() {
      let total = 0;

      this.items.forEach(item => {
        total += item.total_nvt;
      });

      return total;
    },
    totalHedgePosition() {
      let total = 0;

      this.items.forEach(item => {
        total += item.hedge_position_plus;
      });

      return total;
    },
    totalNetPosition() {
      let total = 0;

      this.items.forEach(item => {
        total += item.net_position;
      });

      return total;
    },
    totalClientPl() {
      let total = 0;

      this.items.forEach(item => {
        total += item.total_client_pl;
      });

      return total;
    },
    totalHedgePl() {
      let total = 0;

      this.items.forEach(item => {
        total += Number(item.total_hedge_pl);
      });

      return total;
    },
    totalNetPl() {
      let total = 0;

      this.items.forEach(item => {
        total += Number(item.total_net_pl);
      });

      return total;
    },
    status() {
      if (this.tableView == "login") {
        return `Total ${this.items.length} Unique Logins`
      }else if(this.tableView == "symbol") {
        return `Total ${this.items.length} Unique Symbols`
      }else{
        return `Total ${this.items.length} Login-Symbol Pairs`
      }
    }
  },
  mounted() {
    // User filter list
    if (this.role == "user" || this.role == "operator" || this.role == 'mib') {
      this.options.display_format = ['login'];
      this.fields = [
        { key: "login", stickyColumn: true, sortable: true, label: 'Login' },

        { key: "margin_call", sortable: true, label: 'Margin Call' },
        { key: "fpl", sortable: true, label: 'FPL/B%' },
        { key: "client_position", sortable: true, label: 'Client Position' },
        { key: "lifetime_client_pl", sortable: true, label: 'Lifetime Client PL' },
        { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
        { key: "client_float", sortable: true, label: 'Client Float' },
        { key: "client_settled", sortable: true, label: 'Client Settled' },
        { key: "client_position", sortable: true, label: 'Client Position' },
        { key: "is_flag", sortable: true, label: 'Is Flag' },
        // { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
        // { key: "client_float", sortable: true, label: 'Hedge Float' },
        // { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
        // { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
      ]
    }


    getNvtHedge().then(response => {
      this.nvt.hedge = response.data.data.total;
    })

    this.interval = setInterval(() => {
      this.fetchData(false);
    }, 10000);

    // Watch file upload
    let fileInputElement = this.$refs.file;
    fileInputElement.onchange = () => {
      let formData = new FormData();
      formData.append('file', fileInputElement.files[0]);
      uploadCsv(formData).then(response => {
        this.$bvToast.toast(response.data.message, {
          title: `Success`,
          variant: 'success',
          solid: true
        })
        fileInputElement.value = "";
      })
    };

    if (this.role == "admin") {
      this.tableView = "symbol";

      this.fields = [
          { key: "symbol", stickyColumn: true, sortable: true },
          { key: "client_position", sortable: true, label: 'Client Position' },
          { key: "hedge_position", sortable: true, label: 'Hedge Position' },
          { key: "net_position", sortable: true, label: 'Net Position' },
          { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
          { key: "client_float", sortable: true, label: 'Client Float' },
          { key: "client_settled", sortable: true, label: 'Client Settled' },
          { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
          { key: "hedge_float", sortable: true, label: 'Hedge Float' },
          { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
          { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
        ];
        this.fetchData();
    }else{
      this.fetchData();
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  destroyed() { },
  methods: {
    handleOk() {

      // Update Retention name
      updateUser(this.modal.login, {
        retention_name: this.modal.retention_name
      }).then(() => {
        // Close the modal
        this.items[this.modal.index].retention_name = this.modal.retention_name
        this.$refs['my-modal'].close();
      })
    },
    fetchData(loading = false) {
      if (loading) {
        this.isBusy = true;
      }

      getOpenPositionv2({
        groupBy: this.tableView,
        filterMarginCall: this.filterMarginCall,
        marginLow: this.fil.margin[0],
        marginHight: this.fil.margin[1],
        filterRetentionName: this.filters.retention_name.map(e => e.name)
      })
        .then(data => {
          if (data.data.trades.length > 0) {
            this.items = data.data.trades;
          }
          this.isBusy = false;
        })
        .catch(() => []);
    },
    switchTable() {
      this.items = [];
      this.fetchData();

      if (this.tableView == "symbol") {

        this.fields = [
          { key: "symbol", stickyColumn: true, sortable: true },
          { key: "client_position", sortable: true, label: 'Client Position' },
          { key: "hedge_position", sortable: true, label: 'Hedge Position' },
          { key: "net_position", sortable: true, label: 'Net Position' },
          { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
          { key: "client_float", sortable: true, label: 'Client Float' },
          { key: "client_settled", sortable: true, label: 'Client Settled' },
          { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
          { key: "hedge_float", sortable: true, label: 'Hedge Float' },
          { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
          { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
        ];
      } else if (this.tableView == "login") {
        this.fields = [
          { key: "login", stickyColumn: true, sortable: true, label: 'Login' },
          { key: "retention_name", sortable: true, label: 'Retention Name' },
          { key: "fpl", sortable: true, label: 'FPL/B%' },
          { key: "margin_call", sortable: true, label: 'Margin Call' },
          { key: "client_position", sortable: true, label: 'Client Position' },
          { key: "lifetime_client_pl", sortable: true, label: 'Lifetime Client PL' },
          { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
          { key: "client_float", sortable: true, label: 'Client Float' },
          { key: "client_settled", sortable: true, label: 'Client Settled' },
          { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
          { key: "hedge_float", sortable: true, label: 'Hedge Float' },
          { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
          { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
        ];
        if (this.role == "user" || this.role == "operator" || this.role == 'mib') {

          this.fields = [
            { key: "login", stickyColumn: true, sortable: true, label: 'Login' },
            { key: "client_position", sortable: true, label: 'Client Position' },
            { key: "retention_name", sortable: true, label: 'Retention Name' },
            { key: "margin_call", sortable: true, label: 'Margin Call' },
            { key: "client_position", sortable: true, label: 'Client Position' },
            { key: "lifetime_client_pl", sortable: true, label: 'Lifetime Client PL' },
            { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
            { key: "client_float", sortable: true, label: 'Client Float' },
            { key: "client_settled", sortable: true, label: 'Client Settled' },
            // { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
            // { key: "client_float", sortable: true, label: 'Hedge Float' },
            // { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
            // { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
          ]
        }
      } else {
        // Both
        this.tableView = "both";
        this.fields = [
          { key: "login", stickyColumn: true, sortable: true, label: 'Login' },
          { key: "retention_name", sortable: true, label: 'Retention Name' },
          { key: "symbol", sortable: true, label: 'Symbol' },
          { key: "margin_call", sortable: true, label: 'Margin Call' },
          { key: "client_position", sortable: true, label: 'Client Position' },
          { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
          { key: "client_float", sortable: true, label: 'Client Float' },
          { key: "client_settled", sortable: true, label: 'Client Settled' },
          { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
          { key: "hedge_float", sortable: true, label: 'Hedge Float' },
          { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
          { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
        ]

        if (this.role == "user" || this.role == "operator" || this.role == 'mib') {

          this.fields = [
            { key: "login", stickyColumn: true, sortable: true, label: 'Login' },
            { key: "client_position", sortable: true, label: 'Client Position' },
            { key: "retention_name", sortable: true, label: 'Retention Name' },
            { key: "symbol", sortable: true, label: 'Symbol' },
            { key: "margin_call", sortable: true, label: 'Margin Call' },
            { key: "total_client_pl", sortable: true, label: 'Total Client PL' },
            { key: "client_float", sortable: true, label: 'Client Float' },
            { key: "client_settled", sortable: true, label: 'Client Settled' },
            // { key: "total_hedge_pl", sortable: true, label: 'Total Hedge PL' },
            // { key: "client_float", sortable: true, label: 'Hedge Float' },
            // { key: "hedge_settled", sortable: true, label: 'Hedge Settled' },
            // { key: "total_net_pl", sortable: true, label: 'Total Net PL' },
          ]
        }

      }
    },

    displayBalance(login, data, event) {
      this.$refs['my-modal'].toggle('#toggle-btn')
      if (event) {
        event.preventDefault()
      }

      getBalanceInformation(login).then(response => {
        this.modal = {
          login: data.item.login,
          balance: this.fomatter(response.data.user.balance),
          equity: this.fomatter(response.data.user.equity),
          client_position: this.fomatter(data.item.client_position),
          hedge_position: this.fomatter(data.item.hedge_position),
          net_position: this.fomatter(data.item.net_position),
          retention_name: data.item.retention_name,
          index: data.index,
          total_nvt: this.fomatter(data.item.total_nvt),
          total_open: this.fomatter(response.data.meta.open),
          total_close: this.fomatter(response.data.meta.close),
          credit: response.data.user.credit
        };

      })
    },

    fomatter(value) {
      var formatter = new Intl.NumberFormat("en-US", {

      });

      return formatter.format(value);
    },
    exportExcel() {
      downloadExcel().then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'text/csv'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', "retention_list.csv")
        document.body.appendChild(link)
        link.click()
      })
    },
    chooseFileImport() {
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },
    excel() {
      download(this.tableView).then(response => {
        const url = URL.createObjectURL(new Blob([response.data], {
          type: 'text/csv'
        }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', "exposure.csv")
        document.body.appendChild(link)
        link.click()
      })
    },
    addUser(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
      }
      this.filters.retention_name.push(tag)
      this.fetchData();
    },
    removeRetention() {
      setTimeout(() => {
        this.fetchData();
      }, 800)

    },
    loginChecked(check) {

      // TODO : Update check.is_flag
      if (check.is_flag == "1") {
        check._rowVariant = "success"
      }else{
        check._rowVariant = "light"
      }
      flagUser(check.login, {
        is_flag: check.is_flag
      }).then().catch()
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.tb-exposure {
  max-height: 500px;
}
/* .card-filter {
  position: absolute;
  right: 0;
  top: 30px;
  z-index: 1000;
  min-width: 250px;
} */
</style>
